import React from 'react';

import Footer from '../components/Footer';
import Header from '../components/Header';

// import Card from '../components/Card';

import producer from '../images/filmmakers/LaProducer.JPG';

class Producer extends React.Component {

  render () {

    return (

      <React.Fragment>

        <div className="main producer">

          <Header />

          <div className="content">

            <h2 className="title">LaProducer</h2>

            {/*<Card 
              image={producer}
              title="Mariana García" 
              paragraph="Throughout 17 years as founder and executive producer of TheRep MX, Mariana has become a senior audiovisual producer and post producer leading extensive teams and representing film directors of all sizes, both national and international. She has shot in Argentina, Spain, France, USA, Netherlands, Costa Rica, Canada and of course in Mexico.  Worked for Chinese companies as Tencent and TikTok in various joint ventures. She also has been showrunner of contents and model for the Mexican campaigns of cosmeceutical and beauty Corean industry. Working for the majority ad agencies on a day-to-day basis, she has produced hundreds of tv spots for countless national and transnational brands.  She is always in constant search to improve, treat the team like family and so, all together can satisfy the needs of the projects with a common aim." 
              odd="true"
            />*/}

            <div className="card card_producer odd">

              <div className="card_info">

                <h3 className="card_title">Mariana García</h3>
                <p className="card_paragraph">Throughout 17 years as founder and executive producer of TheRep MX, Mariana has become a senior audiovisual producer and post producer leading extensive teams and representing film directors of all sizes, both national and international.</p>
                <p className="card_paragraph">She has shot in Argentina, Spain, France, USA, Netherlands, Costa Rica, Canada and of course in Mexico.  Worked for Chinese companies as Tencent and TikTok in various joint ventures.</p>
                <p className="card_paragraph">She also has been showrunner of contents and model for the Mexican campaigns of cosmeceutical and beauty Corean industry.</p>
                <p className="card_paragraph">Working for the majority ad agencies on a day-to-day basis, she has produced hundreds of tv spots for countless national and transnational brands.  She is always in constant search to improve, treat the team like family and so, all together can satisfy the needs of the projects with a common aim. </p>
                
              </div>

              <div className="card_frame">
                <img className="card_image" src={producer} alt="card_image" />
              </div>

            </div>

          </div>

          <Footer />

        </div>

      </React.Fragment>

    );
  }
}

export default Producer;
